const Style = {
    title: 'mb-2 flex items-center gap-2 text-sm font-semibold text-text-primary',
    list: 'space-y-2',
    // Compact: chips that wrap, so a long file list still fits a fixed band.
    chips: 'flex flex-wrap gap-2',
    chip: 'max-w-[14rem] py-1 text-xs',
    row: `flex items-center gap-2 rounded-md border border-border px-3 py-2 text-sm
        text-text-secondary transition-colors hover:bg-muted/50`,
    empty: `flex items-center gap-2 rounded-md border border-border px-3 py-2 text-sm text-text-muted`,
};

export default Style;
